import { createSlice } from "@reduxjs/toolkit";
import { store } from "../app/store";

export const eventSlice = createSlice({
  name: "events",
  initialState: {
    events: [],
  },
  reducers: {
    addEvent: (state, { payload }) => {
      let e = payload;
      let events = state.events.filter((o) => o.url!== e.url);
      events.push(e);
      events.sort((a, b) => (a.startdate < b.startdate ? -1 : 1));
      state.events = events;
    },
  },
});

export const selectEvents = (state) => state.events.events;
export const { addEvent } = eventSlice.actions;

async function loadCalendar() {
  //let { data } = await supabase.from("events").select("*");
  let data = await (await fetch('https://cdn.bibspire.dk/calendar.json')).json()
  console.log(data);
  data.sort((a, b) => (a.startdate < b.startdate ? -1 : 1));

  let i = 0;
  let now = new Date().toISOString().slice(0, 10);
  for (const e of data) {
    if (e.startdate < now) continue;
    if (++i > 200) break;
    store.dispatch(eventSlice.actions.addEvent(e));
  }
}
loadCalendar()
